import { defineMessages } from 'react-intl';

export default defineMessages({
    searchAgain: {
        id: 'gateway.views.account-contacts-search.Search Again',
        defaultMessage: 'Search Again',
    },

    addNewContact: {
        id: 'gateway.views.account-contacts-search.Add New Contact',
        defaultMessage: 'Add New Contact',
    },
    noContacts: {
        id: 'gateway.views.account-contacts-search.No results found',
        defaultMessage: 'No contacts has been found based on your criteria.'
    },
    possibleContactMatches: {
        id: 'gateway.views.account-contacts-search.Possible Contact Matches',
        defaultMessage: 'Possible Contact Matches.'
    }
});
